import { handleBackButton, handleSelectTerm, normalizeLanguage } from 'utils'
import { useAppInfo } from 'hooks/useAppInfo'

import { AppBar } from '@interco/inter-ui/components/AppBar'
import { Grid } from '@interco/inter-ui/components/Grid'
import { Card } from '@interco/inter-ui/components/Card'
import { FlexColumn, FlexRow } from '@interco/inter-ui/components/Flex'
import { Text } from '@interco/inter-ui/components/Text'
import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import { IconTheme } from '../IconTheme'
import { TermsListProps } from './types'

export function TermsList({ id, termsData, isLoading = false, onSelectTerm }: TermsListProps) {
  const appInfo = useAppInfo()
  const { language } = appInfo

  const selectedLanguage = normalizeLanguage(language)

  let data = termsData

  if (id) {
    data = data.filter((term) => term.id === id)
  }

  const title: Record<string, string> = {
    'pt-BR': 'Termos e condições',
    'en-US': 'Terms and conditions',
    'es-ES': 'Términos y condiciones',
  }

  const renderSkeleton = () => (
    <Grid className="p-4 gap-y-4">
      {Array.from(Array(3).keys()).map((index) => (
        <Card className="border border-solid border-[var(--gray200)]" key={index}>
          <FlexRow alignItems="center" gap="16px">
            <Skeleton width="24px" height="24px" className="shrink-0" />
            <FlexColumn gap="4px" className="flex-1">
              <Skeleton width="60%" height="16px" />
              <Skeleton width="80%" height="12px" />
            </FlexColumn>
            <Skeleton width="24px" height="24px" className="shrink-0" />
          </FlexRow>
        </Card>
      ))}
    </Grid>
  )

  const handleTermClick = onSelectTerm ?? handleSelectTerm

  return (
    <>
      <AppBar
        leftIcon={
          <IconTheme
            icon="orangeds/MD/arrow-left"
            width={24}
            height={24}
            onClick={handleBackButton}
          />
        }
      >
        {title[selectedLanguage]}
      </AppBar>
      {isLoading ? (
        renderSkeleton()
      ) : (
        <Grid className="p-4 gap-y-4">
          {!!data &&
            data.map((item) => (
              <Card
                className="border border-solid border-[var(--gray200)]"
                key={item.id}
                onClick={() => handleTermClick(item)}
              >
                <FlexRow alignItems="center" gap="16px">
                  <IconTheme
                    icon="orangeds/MD/pdf-file"
                    className="shrink-0"
                    width={24}
                    height={24}
                    color="var(--gray500)"
                  />
                  <FlexColumn gap="4px">
                    <Text variant="body-3" as="p" bold colorWeight={500}>
                      {item.title}
                    </Text>
                    <Text variant="caption-1" as="p">
                      {item.description}
                    </Text>
                  </FlexColumn>
                  <IconTheme
                    icon="orangeds/MD/chevron-right"
                    className="shrink-0"
                    width={24}
                    height={24}
                  />
                </FlexRow>
              </Card>
            ))}
        </Grid>
      )}
    </>
  )
}
